var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-slider',{attrs:{"step":_vm.step,"show-tooltip":false},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }